'use client';

import { styled } from '../../styles';
import { SvgIcon } from '../SvgIcon';
import { Typography } from '../Typography';

export const DataGridCellContainer = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'withSecondValue' && prop !== 'withPadding',
})<{ withSecondValue: boolean; withPadding: boolean }>(
  ({ theme, withSecondValue, withPadding }) => ({
    height: '100%',
    minWidth: 0,
    display: 'flex',
    alignItems: withSecondValue ? 'center' : 'flex-start',
    gap: theme.spacing(2),
    padding: withPadding ? theme.spacing(2) : 0,
  }),
);

export const DataGridCellValueContainer = styled.div(() => ({
  height: '100%',
  minWidth: 0,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column' as any,
  alignItems: 'flex-start',
  justifyContent: 'center',
}));

export const DataGridCellValue = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'disabled' && prop !== 'wrap',
})<{ disabled?: boolean; wrap?: boolean }>(({ onClick, disabled, wrap }) => ({
  minWidth: 0,
  width: '100%',
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: wrap ? 'none' : 'nowrap',
  cursor: onClick ? 'pointer' : 'inherit',
  borderBottom: onClick ? '1px dashed' : 'none',
  opacity: disabled ? 0.5 : 1,
  pointerEvents: disabled ? 'none' : 'auto',
  ':dir(rtl)': {
    direction: 'rtl',
  },
}));

export const DataGridCellIcon = styled(SvgIcon, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size: number }>(({ size }) => ({
  width: size,
  height: size,
}));
